import { PrivilegeTypes } from '@bringg/types';

import useStores from '../../../recipes/use-stores';
import { hasAccess } from '../../../utils/privileges';

export const useCanEditReserveCapacity = (): boolean => {
	const {
		usersStore: { currentUser }
	} = useStores();

	return hasAccess(currentUser, PrivilegeTypes.EDIT_RESERVE_CAPACITY);
};
